import axios from "./http";
import { ProcedureGroupDto, ProcedureGroupSearchRequest, UpsertProcedureGroupDto } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/procedure-group`;

export const getAllProcedureGroupsByTariffId = (tariffId: number, source: CancelTokenSource): Promise<Array<ProcedureGroupDto>> => {
  return axios
      .get(`${apiUri}/tariff/${tariffId}`)
      .then(response => response.data);
};

export const searchProcedureGroup = (procedureGroupSearchRequest: Partial<ProcedureGroupSearchRequest>,
                                      source: CancelTokenSource): Promise<Array<ProcedureGroupDto>> => {
  return axios
      .post(`${apiUri}/search`, procedureGroupSearchRequest, {cancelToken: source.token})
      .then(response => response.data)

};

export const findProcedureGroupById = (procedureGroupId: number): Promise<UpsertProcedureGroupDto> => {
  return axios
      .get(`${apiUri}/${procedureGroupId}`)
      .then(response => response.data)
};

export const addProcedureGroup = (upsertProcedureGroupDto: Partial<UpsertProcedureGroupDto>): Promise<ProcedureGroupDto> => {
  return axios
      .post(apiUri, upsertProcedureGroupDto)
      .then(response => response.data);
};

export const editProcedureGroup = (procedureGroupId: number, upsertProcedureGroupDto: Partial<UpsertProcedureGroupDto>): Promise<ProcedureGroupDto> => {
  return axios
      .put(`${apiUri}/${procedureGroupId}`, upsertProcedureGroupDto)
      .then(response => response.data);
};

export const deleteProcedureGroup = (procedureGroupId: number, source: CancelTokenSource): Promise<ProcedureGroupDto> => {
  return axios
      .delete(`${apiUri}/${procedureGroupId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const availableProcedures = (tariffId: number, source: CancelTokenSource): Promise<Array<number>> => {
  return axios
      .get(`${apiUri}/available/${tariffId}`, {cancelToken: source.token})
      .then(response => response.data);
};
